import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { Modal } from "bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CKYCHome from "../CKYCModule/CKYCHome";
import { baseUrl } from "../index";
import API from "../utils/API";
import { updateTravellerDetails } from "../redux/slices/TravellerDetailsSlice";
import { PfInput, PfMasked, MASKS } from "./ProposalFormFields";

const Contactdetailform = ({
  QuoteInsurerId,
  ProposalMobileNo,
  OncontactDetailSubmit,
  setPincodeState,
  QuoteData,
}) => {
  //console.log("QUOTEINSUREDID", QuoteInsurerId);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const travellerDetails = useSelector((state) => state.TravellerDetails);
  const [isChecked, setIsChecked] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPincodeLoading, setIsPincodeLoading] = useState(false);
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
    if (QuoteData?.insurerId === 112) {
      window.open(QuoteData.wordings, "_blank");
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const [Address1, setAddress1] = useState("");
  const [Address2, setAddress2] = useState("");
  const [Pincode, setPincode] = useState("");
  const [MobileNo, setMobileNo] = useState("");
  const [isAddressValidated, setIsAddressValidated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [fieldTouched, setFieldTouched] = useState({});
  const [formaddressData, setformaddressData] = useState({
    Address1: "",
    Address2: "",
    Pincode: "",
    MobileNo: "",
    stateCity: {},
  });

  useEffect(() => {
    const savedContact =
      travellerDetails?.contactDetails ||
      travellerDetails?.contactAddress ||
      travellerDetails?.addressDetails ||
      {};
    if (savedContact && Object.keys(savedContact).length > 0) {
      setformaddressData((prev) => ({
        ...prev,
        ...savedContact,
        MobileNo:
          savedContact?.MobileNo || ProposalMobileNo || prev.MobileNo || "",
      }));
      const nextErrors = getAddressErrors({
        ...savedContact,
        MobileNo: savedContact?.MobileNo || ProposalMobileNo || "",
      });
      setFieldErrors(nextErrors);
      setIsAddressValidated(
        validateAddressData({
          ...savedContact,
          MobileNo: savedContact?.MobileNo || ProposalMobileNo || "",
        }),
      );
    }
  }, [ProposalMobileNo, travellerDetails]);

  const validateAddressData = (data) => {
    const mobileOk = /^[6-9]\d{9}$/.test(String(data.MobileNo || "").trim());
    const pincodeOk = /^\d{6}$/.test(String(data.Pincode || "").trim());
    const address1Ok = String(data.Address1 || "").trim().length > 0;
    const address2Ok = String(data.Address2 || "").trim().length > 0;
    return mobileOk && pincodeOk && address1Ok && address2Ok;
  };

  const convertDateFormat = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = String(dateString).split("-");
    if (!year || !month || !day) return String(dateString);
    return `${day}-${month}-${year}`;
  };

  const buildProposalState = (contactData, currentTraveller) => {
    const cityState = contactData?.stateCity || {};
    const cityIdParts = String(cityState?.cityId || "").split("~");
    const districtId = Number(cityIdParts[0] || 0);
    const cityId = Number(cityIdParts[1] || 0);

    const member = {
      Salutation: currentTraveller?.salutation || "",
      Gender: currentTraveller?.gender || "",
      FullName: currentTraveller?.fullName || "",
      PassportNumber: currentTraveller?.passportNumber || "",
      enquiryno: QuoteData?.enquiryNo || "",
      Dob: convertDateFormat(currentTraveller?.dob),
      Occupation: currentTraveller?.occupation || "",
      Address1: contactData?.Address1 || "",
      Address2: contactData?.Address2 || "",
      Pincode: contactData?.Pincode || "",
      MobileNo: contactData?.MobileNo || "",
      Email: currentTraveller?.email || "",
      NomineeName: currentTraveller?.nomineeName || "",
      VisaType: currentTraveller?.visaType || "",
      planName: QuoteData?.planName || "",
      Relation: currentTraveller?.Relation || "",
      NomineeRelation: currentTraveller?.trv_nomineerelation || "",
      IsUnderMedication: false,
      productCode: QuoteData?.productCode || "",
      coverageTypeId: String(QuoteData?.coverageTypeId || ""),
      IsVisitingUSACanada: QuoteData?.isVisitingUSACanada || false,
      CityID: cityId,
      StateName: cityState?.state_Name || "",
      CityName: cityState?.cityName || "",
      DistrictID: districtId,
      StateID: Number(cityState?.stateId || 0),
      ExistingIllness: null,
      SufferingSince: null,
      MedicationName: null,
      isMedicine: false,
      CourseDuration: currentTraveller?.courseDuration || null,
      NoOfSems: currentTraveller?.semesterNumber || null,
      UniversityName: currentTraveller?.UniversityName || null,
      isIndianCitizen: null,
      IsResidingInIndia: null,
      isOverseasCitizen: null,
      countryOfPermanentResidence: "",
      ociNumber: "",
      passportIssuingCountry: "",
      isImmigrationVisa: null,
    };

    return {
      KYCDetails: {
        EnquiryNo: QuoteData?.enquiryNo || "",
        TransectionID: "",
        DOB: convertDateFormat(currentTraveller?.dob),
        Name: currentTraveller?.fullName || "",
        Gender: currentTraveller?.gender || "",
        Mobile: contactData?.MobileNo || "",
        Email: currentTraveller?.email || "",
        CompanyID: QuoteData?.insurerID || QuoteData?.InsurerID || "",
        PinCode: contactData?.Pincode || "",
        IsCorporate: false,
        ProductType: 5,
        DocType: "PAN",
        DocNumber: currentTraveller?.ProposerPAN || "",
        Type: 0,
        PolicyType: "0",
        TypeOfPolicy: 1,
        nomineeDetails: { Name: "", RelationShip: "" },
        AddressDetails: {
          PinCode: contactData?.Pincode || "",
          StateName: cityState?.state_Name || "",
          CityName: cityState?.cityName || "",
          AddressLine1: contactData?.Address1 || "",
          AddressLine2: contactData?.Address2 || "",
          AddressLine3: "",
          PerAddressLine1: "",
          PerAddressLine2: "",
          PerAddressLine3: "",
          PerCityName: "",
          PerPinCode: "",
          PerStateName: "",
          IsChangeAddress: "",
        },
      },
      proposalResponse: {
        response: {
          foreName: currentTraveller?.fullName || "",
          lastName: "",
          gender: currentTraveller?.gender || "",
          dob: currentTraveller?.dob || "",
          address1: contactData?.Address1 || "",
          address2: contactData?.Address2 || "",
          email: currentTraveller?.email || "",
          mobileNo: contactData?.MobileNo || "",
          passportNo: currentTraveller?.passportNumber || "",
        },
        transKey: QuoteData?.transKey || QuoteData?.TransKey || "",
      },
      ProposalReq: {
        MemberDetails: [member],
      },
    };
  };

  const getAddressErrors = (data) => {
    const nextErrors = {};
    if (!/^[6-9]\d{9}$/.test(String(data.MobileNo || "").trim())) {
      nextErrors.MobileNo = "Enter valid mobile number";
    }
    if (!String(data.Address1 || "").trim()) {
      nextErrors.Address1 = "Address1 is required";
    }
    if (!String(data.Address2 || "").trim()) {
      nextErrors.Address2 = "Address2 is required";
    }
    if (!/^\d{6}$/.test(String(data.Pincode || "").trim())) {
      nextErrors.Pincode = "Enter valid pincode";
    }
    return nextErrors;
  };

  const handleinputchange = (e) => {
    const { name, value } = e.target;
    const nextData = { ...formaddressData, [name]: value };
    setformaddressData(nextData);
    dispatch(
      updateTravellerDetails({
        ...travellerDetails,
        contactDetails: nextData,
        contactAddress: nextData,
        addressDetails: nextData,
        mobileNo: nextData.MobileNo || travellerDetails?.mobileNo || "",
      }),
    );
    const nextErrors = getAddressErrors(nextData);
    if (fieldTouched[name]) {
      setFieldErrors((prev) => ({ ...prev, [name]: nextErrors[name] || "" }));
    }
    if (name === "Pincode" && String(value || "").length === 6) {
      fetchPincode(value);
    }
    setFieldErrors(nextErrors);
    const isValid = validateAddressData(nextData);
    setIsAddressValidated(isValid);
  };

  const fetchPincode = async (param) => {
    try {
      setIsPincodeLoading(true);

      const body = {
        companyId: String(QuoteInsurerId),
        Pincode: param,
      };

      const response = await API.CallRequestWithHeader({
        URL: "GetCityStateByPincode",
        PostString: JSON.stringify(body),
      });

      if (response?.StatusCode === 200) {
        const responseData = response?.Response || [];
        const stateData = responseData[0] || {};

        setPincodeState(responseData);

        setformaddressData((prevState) => {
          const nextState = {
            ...prevState,
            Pincode: stateData?.pincode || "",
            stateId: stateData?.StateId || "",
            state_Name: stateData?.State_Name || "",
            cityId: stateData?.CityId || "",
            cityName: stateData?.CityName || "",
            districtId: stateData?.DistrictId || "",
            stateCity: {
              stateId: stateData?.StateId || "",
              state_Name: stateData?.State_Name || "",
              cityId: stateData?.CityId || "",
              cityName: stateData?.CityName || "",
              districtId: stateData?.DistrictId || "",
            },
          };

          dispatch(
            updateTravellerDetails({
              ...travellerDetails,
              contactDetails: nextState,
              contactAddress: nextState,
              addressDetails: nextState,
              mobileNo: nextState.MobileNo || travellerDetails?.mobileNo || "",
            }),
          );

          setFieldErrors(getAddressErrors(nextState));
          setIsAddressValidated(validateAddressData(nextState));

          return nextState;
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsPincodeLoading(false);
    }
  };
  const OnpinChange = (e) => {
    let value = e.target.value;
    if (value.length === 6) {
      fetchPincode(value);
    }
  };

  useEffect(() => {
    setformaddressData((prev) => ({
      ...prev,
      MobileNo: ProposalMobileNo || "",
    }));
  }, [ProposalMobileNo]);

  // FIND and REPLACE the entire handleContinue function:
  console.log(formaddressData);

  const handleContinue = async () => {
    if (!isAddressValidated || isSubmitting) return;
    setIsSubmitting(true);
    try {
      // ── Step 1: Save contact/address details ──────────────────────────────
      const contactPayload = {
        EnquiryNo: QuoteData?.enquiryNo || "",
        InsurerID: String(QuoteData?.insurerID || QuoteData?.InsurerID || ""),
        PlanId: Number(
          QuoteData?.PlanId || QuoteData?.planId || QuoteData?.PlansID || 0,
        ),
        QuoteTransKey: QuoteData?.transKey || QuoteData?.TransKey || "",
        LotNo: QuoteData?.lotNo || QuoteData?.LotNo || "",
        AddressDetail: {
          Address1: formaddressData.Address1 || "",
          Address2: formaddressData.Address2 || "",
          Address3: "",
          PinNo: formaddressData.Pincode || "",
          CityId: Number(formaddressData?.stateCity?.cityId || 0),
          StateId: Number(formaddressData?.stateCity?.stateId || 0),
          DistrictId: Number(formaddressData?.stateCity?.districtId || 0),
        },
      };

      const contactRes = await API.CallRequestWithHeader({
        URL: "SaveProposerContactDetails",
        PostString: JSON.stringify(contactPayload),
      });

      const contactOk =
        contactRes?.status === true ||
        contactRes?.response === true ||
        contactRes?.StatusCode === 200 ||
        contactRes?.statusCode === 200;

      if (!contactOk) {
        throw new Error(
          contactRes?.message ||
            contactRes?.Message ||
            "Unable to save contact details",
        );
      }

      // ── Step 2: Get proposal ──────────────────────────────────────────────
      const proposalPayload = {
        EnquiryNo: QuoteData?.enquiryNo || "",
        TransKey: QuoteData?.transKey || QuoteData?.TransKey || "",
        LotNo: QuoteData?.lotNo || QuoteData?.LotNo || "",
        PlanId: Number(
          QuoteData?.PlanId || QuoteData?.planId || QuoteData?.PlansID || 0,
        ),
        InsurerId: Number(QuoteData?.insurerID || QuoteData?.InsurerID || 0),
      };

      const proposalRes = await API.CallRequestWithHeader({
        URL: "GetProposal",
        PostString: JSON.stringify(proposalPayload),
      });

      const proposalOk =
        proposalRes?.StatusCode === 200 ||
        proposalRes?.statusCode === 200 ||
        proposalRes?.status === true ||
        proposalRes?.response?.success === true;

      if (!proposalOk) {
        throw new Error(
          proposalRes?.Message ||
            proposalRes?.message ||
            proposalRes?.response?.errorMsg ||
            "Unable to get proposal",
        );
      }

      // ── Step 3: Persist to Redux + navigate ───────────────────────────────
      const currentTraveller =
        travellerDetails?.travellers?.[0] || QuoteData?.Travellers?.[0] || {};

      const nextState = buildProposalState(formaddressData, currentTraveller);

      dispatch(
        updateTravellerDetails({
          ...travellerDetails,
          contactDetails: formaddressData,
          contactAddress: formaddressData,
          addressDetails: formaddressData,
          mobileNo:
            formaddressData.MobileNo || travellerDetails?.mobileNo || "",
          contactSaved: true,
          proposalResponse: nextState.proposalResponse,
          proposalReq: nextState.ProposalReq,
          proposalData: { MobileNo: formaddressData.MobileNo || "" },
          quoteData: QuoteData,
          travellers: [currentTraveller],
        }),
      );

      navigate("/PaymentSummery", {
        state: {
          ...nextState,
          proposalResponse: proposalRes,
          quoteData: QuoteData,
          ProposalData: { MobileNo: formaddressData.MobileNo || "" },
          travellers: [currentTraveller],
        },
      });
    } catch (error) {
      console.error(error);
      toast.error(error?.message || "Failed to continue");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="ILLnes_CNF">
      <div className="row">
        <div className="col-md-6">
          <div className="input-wrap PRp_TOP">
            <PfMasked
              label="Mobile Number"
              required
              mask={MASKS.mobile}
              guide={false}
              showMask={false}
              name="MobileNo"
              value={formaddressData.MobileNo}
              placeholder="Enter mobile number"
              onChange={(e) => handleinputchange(e)}
              onBlur={() =>
                setFieldTouched((prev) => ({ ...prev, MobileNo: true }))
              }
              error={fieldTouched.MobileNo ? fieldErrors.MobileNo : ""}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="input-wrap PRp_TOP">
            <PfInput
              label="Address1"
              required
              placeholder="Enter address1"
              name="Address1"
              value={formaddressData.Address1}
              onChange={(e) => handleinputchange(e)}
              onBlur={() =>
                setFieldTouched((prev) => ({ ...prev, Address1: true }))
              }
              error={fieldTouched.Address1 ? fieldErrors.Address1 : ""}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="input-wrap PRp_TOP">
            <PfInput
              label="Address2"
              required
              placeholder="Enter address2"
              name="Address2"
              value={formaddressData.Address2}
              onChange={(e) => handleinputchange(e)}
              onBlur={() =>
                setFieldTouched((prev) => ({ ...prev, Address2: true }))
              }
              error={fieldTouched.Address2 ? fieldErrors.Address2 : ""}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="input-wrap PRp_TOP" style={{ position: "relative" }}>
            <PfMasked
              label="Pin Code"
              required
              mask={MASKS.pincode}
              guide={false}
              showMask={false}
              placeholder="Enter pin code"
              name="Pincode"
              value={formaddressData.Pincode}
              onChange={(e) => {
                handleinputchange(e);
                OnpinChange(e);
              }}
              onBlur={() =>
                setFieldTouched((prev) => ({ ...prev, Pincode: true }))
              }
              error={fieldTouched.Pincode ? fieldErrors.Pincode : ""}
              // Pass the city+state badge as a right adornment if PfMasked supports it,
              // otherwise we render it as an absolutely-positioned overlay below.
            />
            {formaddressData?.cityName &&
              formaddressData.Pincode.length === 6 && (
                <div
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    marginTop: 10,
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    zIndex: 2,
                  }}
                >
                  {isPincodeLoading ? (
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        border: "2px solid #d9d9d9",
                        borderTop: "2px solid #1b5e3c",
                        borderRadius: "50%",
                        animation: "spin 0.8s linear infinite",
                      }}
                    />
                  ) : (
                    formaddressData?.cityName &&
                    formaddressData?.Pincode?.length === 6 && (
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#1b5e3c",
                          background: "rgba(27,94,60,0.09)",
                          borderRadius: 999,
                          padding: "2px 8px",
                          whiteSpace: "nowrap",
                          maxWidth: 140,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {formaddressData.cityName}
                        {formaddressData.state_Name
                          ? `, ${formaddressData.state_Name}`
                          : ""}
                      </span>
                    )
                  )}
                </div>
              )}
          </div>
        </div>
      </div>
      <div className="row">
        {/* <div className="terms-container">
          <label>
            <input
              type="checkbox"
              className="checkbox IllNes_Check"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />{" "}
            I agree to the
          </label>
          <span
            onClick={handleOpenPopup}
            style={{ color: "blue", cursor: "pointer" }}
          >
            {" "}
            Terms and Conditions
          </span>

          {isPopupOpen && (
            <div
              className="modal fade AnuthorModal show"
              style={{ display: "block" }}
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header d-flex">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">
                      Terms and Conditions
                    </h1>
                    <button className="CRoss" onClick={handleClosePopup}>
                      X
                    </button>
                  </div>
                  <div className="modal-body">
                    <div>
                      <ul>
                        <li>
                          Policy has been issued based on insured Person(s).
                        </li>
                        <li>
                          1) Is / are not travelling against advice of Medical
                          Practitioner.
                        </li>
                        <li>
                          2) Is / are not on Waiting list for any Medical
                          treatment.
                        </li>
                        <li>
                          3) Is / are not travelling for the purpose of
                          obtaining Medical treatment.
                        </li>
                        <li>
                          4) Have not received a terminal prognosis for a
                          medical condition before Journey.
                        </li>
                        <li>
                          5) Being in India before taking cover and commencement
                          of Trip.
                        </li>
                        <li>6) Being Indian Citizen.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div> */}
      </div>
      <div className="pg-continue-row">
        <button
          type="button"
          className="pg-continue-btn"
          onClick={handleContinue}
          disabled={!isAddressValidated || isSubmitting}
        >
          {isSubmitting ? (
            <>
              Saving...
              <span className="pg-btn-spinner" />
            </>
          ) : (
            <>
              Continue
              <svg
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                viewBox="0 0 16 16"
              >
                <path
                  d="M6 3l5 5-5 5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </>
          )}
        </button>
        {/*<button type="button" className="TraveL-BTN w-50" onClick={() => paymentsummery(formaddressData)} disabled={!isAddressValidated}>Continue <i className="fa fa-angle-right"></i></button>*/}
      </div>
    </div>
  );
};
export default Contactdetailform;
